import React from "react";

function Bone({ className = "" }) {
  return <span className={`inline-block animate-pulse rounded bg-[#E2E8F0] ${className}`} />;
}

const BulkAnalyseKpi = ({ label, value, caption, accent, loading, compact = false }) => {
  const text = value == null ? "" : String(value);
  const valueClass = compact
    ? text.length > 10
      ? "truncate text-[16px] font-bold leading-tight text-[#0F172A]"
      : "text-[22px] font-bold leading-none text-[#0F172A]"
    : "mt-0.5 text-xl font-bold leading-none text-[#0F172A]";

  return (
    <div
      className={`flex items-stretch overflow-hidden border border-[#E5E7EB] bg-white ${
        compact ? "h-[92px] rounded-xl" : "relative min-h-[68px] rounded-xl"
      }`}
    >
      <span className={`w-[3px] shrink-0 ${accent} ${compact ? "" : "absolute inset-y-0 left-0"}`} />
      <div
        className={
          compact
            ? "flex min-w-0 flex-1 flex-col justify-center gap-0.5 px-3.5 py-3"
            : "flex flex-1 flex-col justify-center px-4 py-2"
        }
      >
        <p
          className={compact ? "truncate text-[11px] font-semibold leading-tight text-[#64748B]" : "text-xs font-medium text-[#64748B]"}
          title={label}
        >
          {label}
        </p>
        <p className={valueClass} title={text || undefined}>
          {loading ? <Bone className="h-6 w-10" /> : value}
        </p>
        <p className={compact ? "text-[11px] font-medium leading-none text-[#64748B]" : "mt-1 text-xs leading-snug text-[#64748B]"}>
          {loading ? <Bone className="h-3 w-24" /> : caption}
        </p>
      </div>
    </div>
  );
};

export default BulkAnalyseKpi;
